/**
 * Dropdown options for categorical vehicle fields
 */

export const DROPDOWN_OPTIONS = {
  condition: [
    { title: 'New', value: 'new' },
    { title: 'Used', value: 'used' },
  ],

  state: [
    { title: 'Available', value: 'available' },
    { title: 'Sold', value: 'sold' },
    { title: 'In Transit', value: 'in_transit' },
    { title: 'On Order', value: 'on_order' },
    { title: 'Coming Soon', value: 'coming_soon' },
  ],

  drivetrain: [
    { title: 'Front-Wheel Drive (FWD)', value: 'fwd' },
    { title: 'Rear-Wheel Drive (RWD)', value: 'rwd' },
    { title: 'All-Wheel Drive (AWD)', value: 'awd' },
    { title: 'Four-Wheel Drive (4WD)', value: '4wd' },
    { title: '4x4', value: '4x4' },
  ],

  fuel_type: [
    { title: 'Gasoline', value: 'gas' },
    { title: 'Diesel', value: 'diesel' },
    { title: 'Hybrid', value: 'hybrid' },
    { title: 'Plug-in Hybrid', value: 'plug-in_hybrid' },
    { title: 'Electric', value: 'electric' },
    { title: 'Flex Fuel', value: 'flex_fuel' },
    { title: 'CNG', value: 'cng' },
  ],

  vehicle_type: [
    { title: 'Sedan', value: 'sedan' },
    { title: 'Coupe', value: 'coupe' },
    { title: 'Hatchback', value: 'hatchback' },
    { title: 'SUV', value: 'suv' },
    { title: 'Truck', value: 'truck' },
    { title: 'Van', value: 'van' },
    { title: 'Minivan', value: 'minivan' },
    { title: 'Wagon', value: 'wagon' },
    { title: 'Convertible', value: 'convertible' },
    { title: 'Crossover', value: 'crossover' },
  ],

  body_type: [
    { title: 'Sedan', value: 'sedan' },
    { title: 'Coupe', value: 'coupe' },
    { title: 'Hatchback', value: 'hatchback' },
    { title: 'SUV', value: 'suv' },
    { title: 'Truck', value: 'truck' },
    { title: 'Van', value: 'van' },
    { title: 'Minivan', value: 'minivan' },
    { title: 'Wagon', value: 'wagon' },
    { title: 'Convertible', value: 'convertible' },
    { title: 'Crossover', value: 'crossover' },
  ],

  transmission: [
    { title: 'Automatic', value: 'automatic' },
    { title: 'Manual', value: 'manual' },
    { title: 'CVT', value: 'cvt' },
    { title: 'Dual Clutch', value: 'dual_clutch' },
    { title: '6-Speed Automatic', value: '6-speed_automatic' },
    { title: '8-Speed Automatic', value: '8-speed_automatic' },
    { title: '10-Speed Automatic', value: '10-speed_automatic' },
  ],

  cab_style: [
    { title: 'Regular Cab', value: 'regular' },
    { title: 'Extended Cab', value: 'extended' },
    { title: 'Crew Cab', value: 'crew' },
    { title: 'Quad Cab', value: 'quad' },
    { title: 'Double Cab', value: 'double' },
    { title: 'Super Cab', value: 'super' },
  ],
} as const

/**
 * Number field constraints for validation
 */
export const NUMBER_CONSTRAINTS = {
  year: { min: 1900, max: new Date().getFullYear() + 2, step: 1 },
  mileage: { min: 0, max: 999999, step: 1 },
  price: { min: 0, max: 99999999, step: 1 },
  msrp: { min: 0, max: 99999999, step: 1 },
  discount: { min: 0, max: 99999999, step: 1 },
  doors: { min: 2, max: 8, step: 1 },
  passenger_capacity: { min: 1, max: 20, step: 1 },
  gvwr: { min: 0, max: 999999, step: 1 },
  mpg_city_average: { min: 0, max: 150, step: 0.1 },
  mpg_highway_average: { min: 0, max: 150, step: 0.1 },
  mpg_city_low: { min: 0, max: 150, step: 1 },
  mpg_city_high: { min: 0, max: 150, step: 1 },
  mpg_highway_low: { min: 0, max: 150, step: 1 },
  mpg_highway_high: { min: 0, max: 150, step: 1 },
  ev_battery_range: { min: 0, max: 9999, step: 1 },
  ev_mpg_combined: { min: 0, max: 999, step: 1 },
} as const

/**
 * Helper to get dropdown options for a field
 */
export function getDropdownOptions(field: string): readonly { title: string; value: string }[] | undefined {
  return DROPDOWN_OPTIONS[field as keyof typeof DROPDOWN_OPTIONS]
}

/**
 * Helper to get number constraints for a field
 */
export function getNumberConstraints(field: string): { min: number; max: number; step: number } | undefined {
  return NUMBER_CONSTRAINTS[field as keyof typeof NUMBER_CONSTRAINTS]
}

